import { C } from "../lib/colors";
import { PageShell } from "../components/PageShell";
import { SITE } from "../lib/site";

export const TermsPage = ({ onNavigate, authRole }) => {
  const Section = ({title, children}) => (
    <div style={{marginBottom:40}}>
      <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:20,fontWeight:700,letterSpacing:-0.5,
        marginBottom:14,color:"#fff",paddingBottom:10,borderBottom:`1px solid ${C.border}`}}>{title}</h2>
      <div style={{fontSize:15,color:"rgba(255,255,255,0.65)",lineHeight:1.85}}>{children}</div>
    </div>
  );
  return (
    <PageShell onNavigate={onNavigate} authRole={authRole}>
      <div style={{maxWidth:740,margin:"0 auto",padding:"64px 24px"}}>
        <div style={{marginBottom:52}}>
          <div style={{fontSize:11,fontWeight:700,letterSpacing:2.5,textTransform:"uppercase",color:C.green,
            marginBottom:14,fontFamily:"'DM Mono',monospace"}}>Legal</div>
          <h1 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(32px,5vw,48px)",fontWeight:800,
            letterSpacing:-2,marginBottom:14}}>Terms of Service</h1>
          <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
            <span style={{fontSize:13,color:C.muted}}>Last updated: May 1, 2025</span>
            <span style={{fontSize:13,color:C.muted}}>·</span>
            <button onClick={()=>onNavigate("privacy")} style={{background:"none",border:"none",
              color:C.green,fontSize:13,cursor:"pointer",fontFamily:"'Instrument Sans',sans-serif"}}>
              View Privacy Policy →
            </button>
          </div>
        </div>

        <div style={{background:`${C.amber}08`,border:`1px solid ${C.amber}25`,borderRadius:12,
          padding:"16px 20px",marginBottom:40,fontSize:13,color:"rgba(255,255,255,0.6)",lineHeight:1.7}}>
          Please read these Terms of Service carefully before using Media on Auto Pilot. By accessing or using our services, you agree to be bound by these terms. If you do not agree, please do not use our services.
        </div>

        <Section title="1. Acceptance of Terms">
          By creating an account, placing an order, or using any part of our platform, you agree to these Terms of Service and our Privacy Policy. These terms apply to all users including visitors, clients, and anyone who accesses the platform.
        </Section>

        <Section title="2. Description of Services">
          Media on Auto Pilot provides AI-assisted content creation services including SEO blog posts, social media captions, content strategy, and related deliverables on a monthly subscription basis. The specific deliverables included in your plan are as described on our pricing page at the time of your subscription.
        </Section>

        <Section title="3. Subscriptions and Billing">
          <ul style={{paddingLeft:22,display:"flex",flexDirection:"column",gap:8}}>
            {["Subscriptions are billed monthly in advance on the date you first subscribe","All payments are processed securely by Stripe","Prices are in USD and exclusive of any applicable taxes","We reserve the right to update pricing with 30 days' notice","Failed payments may result in a temporary suspension of your account until payment is resolved"].map((i,idx)=>(
              <li key={idx}>{i}</li>
            ))}
          </ul>
        </Section>

        <Section title="4. Cancellation and Refunds">
          You may cancel your subscription at any time with 7 days' notice before your next billing date. Cancellations take effect at the end of your current billing period — you retain access until then. We do not offer refunds for partial months. If you are dissatisfied with any content deliverable, we will revise it at no charge within 7 days of delivery. This is our satisfaction guarantee.
        </Section>

        <Section title="5. Content Ownership">
          Upon receipt of full payment for a given month, all content delivered to you becomes your property. You may publish, edit, and use the content in any way you see fit. Media on Auto Pilot retains no rights to content delivered to you after payment. We may use anonymised examples of our work in our marketing materials unless you request otherwise.
        </Section>

        <Section title="6. Your Responsibilities">
          <ul style={{paddingLeft:22,display:"flex",flexDirection:"column",gap:8}}>
            {["Provide accurate business information during onboarding","Review delivered content before publishing and ensure it is accurate for your business","Keep your account credentials secure and confidential","Not share your client portal access with third parties","Ensure any content you publish complies with the laws of your jurisdiction","Not use our services for any unlawful, harmful, or deceptive purpose"].map((i,idx)=>(
              <li key={idx}>{i}</li>
            ))}
          </ul>
        </Section>

        <Section title="7. Intellectual Property">
          The Media on Auto Pilot platform, including its design, software, and branding, is owned by Media on Auto Pilot and protected by applicable intellectual property laws. You may not copy, reproduce, or create derivative works from our platform without written permission.
        </Section>

        <Section title="8. Limitation of Liability">
          Media on Auto Pilot provides content services in good faith but does not guarantee specific SEO rankings, traffic levels, or business outcomes. Results depend on many factors outside our control. To the maximum extent permitted by law, Media on Auto Pilot's total liability to you for any claim arising from these terms or our services shall not exceed the amount you paid us in the 30 days preceding the claim.
        </Section>

        <Section title="9. Disclaimer of Warranties">
          Our services are provided "as is" and "as available". We make no warranty that the service will be uninterrupted, error-free, or meet your specific requirements. We do not warrant that AI-generated content will be free from inaccuracies — you are responsible for reviewing all content before publishing.
        </Section>

        <Section title="10. Termination">
          We reserve the right to suspend or terminate your account if you violate these Terms of Service, fail to pay your subscription, or engage in conduct that we determine is harmful to other users or to Media on Auto Pilot. You will be notified before termination where reasonably possible.
        </Section>

        <Section title="11. Changes to Terms">
          We may update these Terms of Service from time to time. We will notify you of material changes by email at least 14 days before they take effect. Continued use of our services after the effective date constitutes acceptance of the updated terms.
        </Section>

        <Section title="12. Governing Law">
          These terms are governed by the laws of the State of {SITE.legalState}, United States, without regard to conflict of law principles. Any disputes shall be resolved in the courts located in {SITE.legalCity}, {SITE.legalState}.
        </Section>

        <Section title="13. Contact Us">
          If you have questions about these Terms of Service, please contact us:<br/><br/>
          <strong style={{color:"#fff"}}>Media on Auto Pilot</strong><br/>
          Email: {SITE.legalEmail}<br/>
          Website: mediaonautopilot.com
        </Section>

        <div style={{background:`${C.green}07`,border:`1px solid ${C.green}20`,borderRadius:12,padding:"18px 22px",
          display:"flex",alignItems:"center",justifyContent:"space-between",gap:16,flexWrap:"wrap"}}>
          <div style={{fontSize:13,color:C.muted}}>Also read our Privacy Policy for how we collect and use your data.</div>
          <button onClick={()=>onNavigate("privacy")} style={{background:C.green,border:"none",borderRadius:8,
            padding:"9px 20px",color:"#000",fontSize:13,fontWeight:700,cursor:"pointer",
            fontFamily:"'Instrument Sans',sans-serif",whiteSpace:"nowrap"}}>
            Privacy Policy →
          </button>
        </div>
      </div>
    </PageShell>
  );
};
